var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['rating__starts', 'is-' + _vm.state]},[_c('star-rating',{attrs:{"increment":_vm.increment,"max-rating":_vm.maxRating,"starSize":_vm.starSize,"read-only":_vm.readOnly,"show-rating":_vm.showRating},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }